export const APPLY_TYPE = Object.freeze({
  VACATION: {
    KEY: 'vacation',
    NAME: '휴가',
  },
  WORK_HOME: {
    KEY: 'workHome',
    NAME: '재택근무',
  },
  OUTSIDE_OFFICE: {
    KEY: 'outsideOffice',
    NAME: '출장 및 외근신청',
  },
  MEAL_COST: {
    KEY: 'mealCost',
    NAME: '식대비',
    TYPE: {
      NIGHT_SHIFT: {
        KEY: 'nightShift',
        NAME: '야근',
      },
      HOLIDAY_WORK: {
        KEY: 'holidayWork',
        NAME: '휴일근무',
      },
      GANGNAM: {
        KEY: 'gangNam',
        NAME: '기타',
      },
    },
  },
  MEAL_COST_LABEL: {
    nightShift: '야근 식대비',
    holidayWork: '휴일근무 식대비',
    gangNam: '기타',
  },
  EXPENSE_REPORT: {
    KEY: 'expenseReport',
    NAME: '지출결의서',
    TYPE: {
      COST_ETC: {
        KEY: 'costEtc',
        NAME: '기타 지출비',
      },
      COST_TAXI: {
        KEY: 'costTaxi',
        NAME: '심야 택시비',
      },
    },
  },
  SUBMIT: {
    KEY: 'submit',
    NAME: '품의서',
  },
  HOLIDAY_WORK: {
    KEY: 'holidayWork',
    NAME: '휴일근무',
  },
  ADMIT_REQUEST: {
    KEY: 'admitRequest',
    NAME: '인정휴가 지급',
  },
  BUSINESS_TRIP: {
    KEY: 'businessTrip',
    NAME: '출장결과보고서',
    TYPE: {
      PAY: {
        KEY: 'pay',
        NAME: '일당',
      },
      COST_TRANSPORT: {
        KEY: 'costTransport',
        NAME: '대중교통',
      },
      COST_ETC: {
        KEY: 'costEtc',
        NAME: '기타',
      },
    },
  },
});

// export const APPLY_TYPE = Object.freeze({
//   VACATION: {
//     "KEY": "vacation",
//     "NAME": "휴가"
//   },
//   WORK_HOME: {
//     "KEY": "workHome",
//     "NAME": "재택근무"
//   },
//   OUTSIDE_OFFICE: {
//     "KEY": "outsideOffice",
//     "NAME": "출장 및 외근신청"
//   },
//   MEAL_COST: {
//     "KEY": "mealCost",
//     "NAME": "식대비",
//     "TYPE": {
//       "NIGHT_SHIFT": {
//         "KEY": "nightShift",
//         "NAME": "야근"
//       },
//       "HOLIDAY_WORK": {
//         "KEY": "holidayWork",
//         "NAME": "휴일근무"
//       },
//       "GANGNAM": {
//         "KEY": "gangNam",
//         "NAME": "강남 사무실"
//       }
//     }
//   },
//   MEAL_COST_LABEL: {
//     nightShift: '야근 식대비',
//     holidayWork: '휴일근무 식대비',
//     gangNam: '강남 식대비'
//   },
//   EXPENSE_REPORT: {
//     "KEY": "expenseReport",
//     "NAME": "지출결의서",
//     "TYPE": {
//       "COST_ETC": {
//         "KEY": "costEtc",
//         "NAME": "기타 지출비"
//       },
//       "COST_TAXI": {
//         "KEY": "costTaxi",
//         "NAME": "심야 택시비"
//       }
//     }
//   },
//   SUBMIT: {
//     "KEY": "submit",
//     "NAME": "품의서"
//   },
//   HOLIDAY_WORK: {
//     "KEY": "holidayWork",
//     "NAME": "휴일근무"
//   },
//   ADMIT_REQUEST: {
//     "KEY": "admitRequest",
//     "NAME": "인정휴가 지급"
//   },
//   BUSINESS_TRIP: {
//     "KEY": "businessTrip",
//     "NAME": "출장결과보고서",
//     "TYPE": {
//       "PAY": {
//         "KEY": "pay",
//         "NAME": "일당"
//       },
//       "COST_TRANSPORT": {
//         "KEY": "costTransport",
//         "NAME": "대중교통"
//       },
//       "COST_ETC": {
//         "KEY": "costEtc",
//         "NAME": "기타"
//       }
//     }
//   }
// })

export const EMPLOYEE_STAT = {
  WORKING: '재직',
  ABSENCE: '휴직',
  LEFT: '퇴직',
};
Object.freeze(EMPLOYEE_STAT);

export const EMPLOYEE_STAT2 = {
  WORKING: '재직',
  ABSENCE: '휴직',
  LEFT: '퇴직',
};
Object.freeze(EMPLOYEE_STAT2);

export const VACATION_TYPE = {
  allDay: '종일휴가',
  AM: '오전반차',
  PM: '오후반차',
  admit: '인정휴가',
  admitAm: '인정오전반차',
  admitPm: '인정오후반차',
  cancle: '휴가취소',
  notVacation: '-',
};
Object.freeze(VACATION_TYPE);

export const VACATION_PERIOD = {
  allDay: 1,
  AM: 0.5,
  PM: 0.5,
  admit: 1,
  admitAm: 0.5,
  admitPm: 0.5,
};

export const VACATION_UPDATE_TYPE = {
  EMPTY: {
    KEY: 'empty',
    NAME: ' - ',
  },
  UPDATE: {
    KEY: 'update',
    NAME: '변경',
  },
  CANCEL: {
    KEY: 'vacationCancel',
    NAME: '휴가 취소',
  },
};
Object.freeze(VACATION_TYPE);

export const VACATION_TYPE2 = {
  ALL_DAY: {
    KEY: 'allDay',
    NAME: '종일휴가',
  },
  AM: {
    KEY: 'AM',
    NAME: '오전반차',
  },
  PM: {
    KEY: 'PM',
    NAME: '오후반차',
  },
  ADMIT: {
    KEY: 'admit',
    NAME: '인정휴가(종일)',
  },
  ADMIT_AM: {
    KEY: 'admitAm',
    NAME: '인정휴가(오전)',
  },
  ADMIT_PM: {
    KEY: 'admitPm',
    NAME: '인정휴가(오후)',
  },
  CANCEL: {
    KEY: 'cancel',
    NAME: '휴가취소',
  },
  NOT_VACATION: {
    KEY: 'notVacation',
    NAME: '-',
  },
};
Object.freeze(VACATION_TYPE2);

export const APPROVAL_STATE = {
  APPROVE: {
    KEY: 'approve',
    NAME: '승인',
  },
  REJECT: {
    KEY: 'reject',
    NAME: '반려',
  },
  IN_PROGRESS: {
    KEY: 'inProgress',
    NAME: '진행중',
  },
  COMPLETE: {
    KEY: 'complete',
    NAME: '결재완료',
  },
  APPLIED: {
    KEY: 'applied',
    NAME: '신청완료',
  },
  CANCEL: {
    KEY: 'cancel',
    NAME: '결재취소',
  },
};
Object.freeze(APPROVAL_STATE);

export const APPROVAL_BOX_STATE = {
  APPROVE: {
    KEY: 'approve',
    NAME: '승인',
  },
  REJECT: {
    KEY: 'reject',
    NAME: '반려',
  },
  UNAPPROVED: {
    KEY: 'inProgress',
    NAME: '미결재',
  },
};
Object.freeze(APPROVAL_BOX_STATE);

export const APPROVAL_BOARD_STATE_RECEPTION = {
  COMPLETE: {
    KEY: 'complete',
    NAME: '결재완료',
  },
  APPROVE: {
    KEY: 'approve',
    NAME: '승인',
  },
  REJECT: {
    KEY: 'reject',
    NAME: '반려',
  },
  UNAPPROVED: {
    KEY: 'unapproved',
    NAME: '미결재',
  },
  IN_PROGRESS: {
    KEY: 'applied,inProgress',
    NAME: '진행중',
  },
};
Object.freeze(APPROVAL_BOARD_STATE_RECEPTION);

export const APPROVAL_STATE_REFERENCE = {
  COMPLETE: {
    KEY: 'complete',
    NAME: '결재완료',
  },
  REJECT: {
    KEY: 'reject',
    NAME: '반려',
  },
  IN_PROGRESS: {
    KEY: 'applied,inProgress',
    NAME: '결재 진행중',
  },
};
Object.freeze(APPROVAL_STATE_REFERENCE);

export const WORK_STAT = {
  NOMAL: {
    KEY: 'normal',
    NAME: '정상출근',
  },
  LATE: {
    KEY: 'late',
    NAME: '지각',
  },
  TRUANCY: {
    KEY: 'truancy',
    NAME: '결근',
  },
  ABSENCE: {
    KEY: 'absence',
    NAME: '휴직',
  },
  HOME: {
    KEY: 'home',
    NAME: '재택',
  },
  DISPATCH: {
    KEY: 'dispatch',
    NAME: '파견',
  },
  HOLIDAY: {
    KEY: 'holiday',
    NAME: '주말',
  },
  AM: {
    KEY: 'AM',
    NAME: '오전반차',
  },
  PM: {
    KEY: 'PM',
    NAME: '오후반차',
  },
  ALL_DAY: {
    KEY: 'allDay',
    NAME: '종일휴가',
  },
  ADMIT: {
    KEY: 'admit',
    NAME: '인정휴가',
  },
  CANCEL: {
    KEY: 'cancel',
    NAME: '휴가취소',
  },
  ADMIT_AM: {
    KEY: 'admitAm',
    NAME: '인정오전반차',
  },
  ADMIT_PM: {
    KEY: 'admitPm',
    NAME: '인정오후반차',
  },
  NO_VACATION: {
    KEY: 'notVacation',
    NAME: '-',
  },
};
Object.freeze(WORK_STAT);

export const WORK_STAT2 = {
  NOMAL: {
    KEY: 'normal',
    NAME: '정상출근',
  },
  LATE: {
    KEY: 'late',
    NAME: '지각',
  },
  TRUANCY: {
    KEY: 'truancy',
    NAME: '결근',
  },
  ABSENCE: {
    KEY: 'absence',
    NAME: '휴직',
  },
  HOME: {
    KEY: 'home',
    NAME: '재택',
  },
  DISPATCH: {
    KEY: 'dispatch',
    NAME: '파견',
  },
  HOLIDAY: {
    KEY: 'holiday',
    NAME: '주말',
  },
  NO_VACATION: {
    KEY: 'notVacation',
    NAME: '-',
  },
};
Object.freeze(WORK_STAT);

export const WORK_PLACE = {
  HEAD_OFFICE: {
    KEY: 'headOffice',
    NAME: '본사',
  },
  GANGNAM: {
    KEY: 'gangNam',
    NAME: '강남',
  },
  HOME: {
    KEY: 'home',
    NAME: '재택',
  },
};
Object.freeze(WORK_PLACE);

export const POSITION = [
  { name: '대표이사', class: 'chip-red', value: 1 } /*title 수정됨*/,
  { name: '부사장', class: 'chip-blue', value: 2 } /*추가됨*/,
  { name: '상무', class: 'chip-pink', value: 3 } /*2였음*/,
  { name: '이사', class: 'chip-purple', value: 4 } /*3이였음*/,
  { name: '팀장', class: 'chip-teal', value: 5 },
  { name: '과장', class: 'chip-brown', value: 6 } /*4였음*/,
  { name: '수석 PRO', class: 'chip-green', value: 7 } /*6이였음*/,
  { name: '수석', class: 'chip-green', value: 8 } /*7이였음*/,
  { name: '선임 PRO', class: 'chip-orange', value: 9 } /*8이였음*/,
  { name: '선임', class: 'chip-orange', value: 10 } /*9였음*/,
  { name: '대리', class: 'chip-primary', value: 11 } /*추가됨*/,
  { name: '사원', class: 'chip-gray', value: 12 } /*추가됨*/,
];
Object.freeze(POSITION);

export const JOB_ID = [
  { name: '프론트엔드', value: '프론트엔드', jobId: 1 },
  { name: '백엔드', value: '백엔드', jobId: 2 },
  { name: 'QA', value: 'QA', jobId: 3 },
  { name: '퍼블리셔', value: '퍼블리셔', jobId: 4 },
  { name: '디자이너', value: '디자이너', jobId: 5 },
];

export const CERTIFICATE = {
  receipt: '전년도 원천징수 영수증',
  certificateEmployment: '재직증명서',

  N: '미발급',
  Y: '발급 완료',
};
Object.freeze(CERTIFICATE);

export const CERTIFICATE_TYPE = {
  KEY: 'type',
  VALUES: {
    RECEIPT: {
      KEY: 'receipt',
      NAME: '전년도 원천징수 영수증',
    },
    CERTIFICATE_EMP: {
      KEY: 'certificateEmployment',
      NAME: '재직증명서',
    },
  },
};
Object.freeze(CERTIFICATE_TYPE);

export const CERTIFICATE_STATE = {
  KEY: 'state',
  VALUES: {
    Y: {
      KEY: 'Y',
      NAME: '발급완료',
    },
    N: {
      KEY: 'N',
      NAME: '미발급',
    },
  },
};
Object.freeze(CERTIFICATE_STATE);

export const PERMISSION = {
  0: '관리자',
  1: '매니저',
  2: '일반사용자',
};
Object.freeze(PERMISSION);

export const PERMISSION2 = {
  ADMIN: {
    KEY: '0',
    NAME: '관리자',
  },
  MANAGER: {
    KEY: '1',
    NAME: '매니저',
  },
  USER: {
    KEY: '2',
    NAME: '일반사용자',
  },
};
Object.freeze(PERMISSION2);

export const START_END_TYPE = {
  START: {
    KEY: 'start',
    NAME: '출근 시간 변경',
  },
  END: {
    KEY: 'end',
    NAME: '퇴근 시간 변경',
  },
  START_END: {
    KEY: 'startEnd',
    NAME: '출퇴근 시간 변경',
  },
};

export const alarmCate = {
  // cate: {
  //   item: {
  //     action: {

  //     }
  //   }
  // },
  employee: {
    //인사관리
    rank: {
      //직급
      change: {
        class: 'aunnounce-hr',
        icon: 'icon-supervisor-account',
        path: '',
      },
    },
    team: {
      //부서
      change: {
        class: 'aunnounce-hr',
        icon: 'icon-supervisor-account',
        path: '',
      },
    },
    receipt: {
      //전년도 원천징수 영수증
      request: {
        class: 'aunnounce-hr',
        icon: 'icon-supervisor-account',
        path: '/hr/management/receptionbox',
      },
    },
    certificate: {
      //재직 증명서
      request: {
        class: 'aunnounce-hr',
        icon: 'icon-supervisor-account',
        path: '/hr/management/receptionbox',
      },
    },
  },

  attendance: {
    //근태 관리
    attendance: {
      change: {
        class: 'aunnounce-attandance-accept',
        icon: 'icon-business-center',
        path: '/attendance/gatetime/current',
      },
      approve: {
        class: 'aunnounce-attandance-accept',
        icon: 'icon-business-center',
        path: '/attendance/gatetime/applied',
      },
      request: {
        class: 'aunnounce-attandance-accept',
        icon: 'icon-business-center',
        path: '/attendance/gatetime/current',
      },
      reject: {
        class: 'aunnounce-reject',
        icon: 'icon-business-center',
        path: '/attendance/gatetime/applied',
      },
    },
  },

  vacation: {
    //연차관리
    vacationManage: {
      change: {
        class: 'aunnounce-vacation',
        icon: 'icon-beach-access',
        path: '/vacation/status/current',
      },
      alert: {
        class: 'aunnounce-vacation',
        icon: 'icon-beach-access',
        path: 'https://mail.google.com/mail/u/0/#inbox',
      },
    },
    admit: {
      alert: {
        class: 'aunnounce-vacation',
        icon: 'icon-beach-access',
        path: '/approval/apply/vacation',
      },
    },
  },

  approval: {
    //결재 관리
    application: {
      //미결재 건
      request: {
        class: 'aunnounce-approval-receive',
        icon: 'icon-payments',
        path: '/approval/box/reception/vacation',
      },
    },
    vacationUpdate: {
      //휴가 취소 요청 건
      approve: {
        class: 'aunnounce-approval-accept',
        icon: 'icon-beach-access',
        path: '',
      },
      reject: {
        class: 'aunnounce-reject',
        icon: 'icon-beach-access',
        path: '',
      },
    },
    expenseReport: {
      //지출 결의서
      approve: {
        class: 'aunnounce-approval-accept',
        icon: 'icon-credit-card',
        path: '',
      },
      reject: {
        class: 'aunnounce-reject',
        icon: 'icon-credit-card',
        path: '',
      },
    },
    mealCost: {
      //식대비
      approve: {
        class: 'aunnounce-approval-accept',
        icon: 'icon-fastfood',
        path: '',
      },
      reject: {
        class: 'aunnounce-reject',
        icon: 'icon-fastfood',
        path: '',
      },
    },
    submit: {
      //품의서
      approve: {
        class: 'aunnounce-approval-accept',
        icon: 'icon-description',
        path: '',
      },
      reject: {
        class: 'aunnounce-reject',
        icon: 'icon-description',
        path: '',
      },
    },
    holidayWork: {
      //휴일 근무
      approve: {
        class: 'aunnounce-approval-accept',
        icon: 'icon-work',
        path: '',
      },
      reject: {
        class: 'aunnounce-reject',
        icon: 'icon-work',
        path: '',
      },
    },
    admitRequest: {
      //인정 휴가 지급
      approve: {
        class: 'aunnounce-approval-accept',
        icon: 'icon-domain-verification',
        path: '',
      },
      reject: {
        class: 'aunnounce-reject',
        icon: 'icon-domain-verification',
        path: '',
      },
    },
    businessTrip: {
      //출장결과보고서
      approve: {
        class: 'aunnounce-approval-accept',
        icon: 'icon-luggage',
        path: '',
      },
      reject: {
        class: 'aunnounce-reject',
        icon: 'icon-luggage',
        path: '',
      },
    },
  },
  notice: {
    notice: {
      request: {
        class: 'aunnounce-notice',
        icon: 'icon-campaign',
        path: '',
      },
    },
  },
};

// ============================== new ===============================
export const APPROVAL_STATE_APPLIED = Object.freeze({
  APPROVE: {
    KEY: 'complete',
    NAME: '결재완료',
  },
  APPLIED: {
    KEY: 'applied',
    NAME: '신청완료',
  },
  IN_PROGRESS: {
    KEY: 'inProgress',
    NAME: '진행중',
  },
  REJECT: {
    KEY: 'reject',
    NAME: '반려',
  },
  CANCEL: {
    KEY: 'cancel',
    NAME: '결재취소',
  },
});

export const APPROVAL_BOARD_STATE_RECEPTION_NEW = Object.freeze({
  COMPLETE: {
    KEY: 'complete',
    NAME: '결재완료',
  },
  APPROVE: {
    KEY: 'approve',
    NAME: '승인',
  },
  REJECT: {
    KEY: 'reject',
    NAME: '반려',
  },
  UNAPPROVED: {
    KEY: 'unapproved',
    NAME: '미결재',
  },
  IN_PROGRESS: {
    KEY: 'inProgress',
    NAME: '진행중',
  },
});

export const VACATION_APPROVAL_STATE_APPLIED = Object.freeze({
  APPROVE: {
    KEY: 'cancel',
    NAME: '승인',
  },
  REJECT: {
    KEY: 'reject',
    NAME: '반려',
  },
  UNAPPROVED: {
    KEY: 'inProgress',
    NAME: '진행중',
  },
});

export const VACATION_APPROVAL_STATE_RECEPTION = Object.freeze({
  APPROVE: {
    KEY: 'approve',
    NAME: '승인',
  },
  REJECT: {
    KEY: 'reject',
    NAME: '반려',
  },
  UNAPPROVED: {
    KEY: 'inProgress',
    NAME: '미결재',
  },
});

export const APPROVAL_BOARD_STATE_REFERENCE_NEW = Object.freeze({
  COMPLETE: {
    KEY: 'complete',
    NAME: '결재완료',
  },
  REJECT: {
    KEY: 'reject',
    NAME: '반려',
  },
  IN_PROGRESS: {
    KEY: 'inProgress',
    NAME: '결재 진행중',
  },
});

export const VACATION_TYPE_APPLIED = Object.freeze({
  ALL_DAY: {
    KEY: 'allDay',
    NAME: '종일휴가',
  },
  AM: {
    KEY: 'AM',
    NAME: '오전반차',
  },
  PM: {
    KEY: 'PM',
    NAME: '오후반차',
  },
  ADMIT: {
    KEY: 'admit',
    NAME: '인정휴가(종일)',
  },
  ADMIT_AM: {
    KEY: 'admitAm',
    NAME: '인정휴가(오전)',
  },
  ADMIT_PM: {
    KEY: 'admitPm',
    NAME: '인정휴가(오후)',
  },
  CANCEL: {
    KEY: 'cancel',
    NAME: '휴가취소',
  },
});

export const VACATION_TYPE_NEW = Object.freeze({
  allDay: '종일휴가',
  AM: '오전반차',
  PM: '오후반차',
  admit: '인정휴가',
  admitAm: '인정오전반차',
  admitPm: '인정오후반차',
});

export const MEAL_COST_NEW = Object.freeze({
  nightShift: '야근',
  holidayWork: '휴일근무',
  gangNam: '기타',
});

export const TimeTableTaskType = Object.freeze({
  EXECUTE: '프로젝트 수행',
  AFTER_SVC: '하자보수',
  RESEARCH: '연구개발(R&D)',
  SUGGEST: '제안서 작업',
  NORMAL: '기타(일반업무)',
});

export const TimetablePeriod = Object.freeze({
  MONTH: '월별',
  QUARTER: '분기별',
  YEAR: '연도별',
  PERIOD: '기간별',
});

export const TimetableQuarter = Object.freeze({
  Q1: '1분기',
  Q2: '2분기',
  Q3: '3분기',
  Q4: '4분기',
});

export const ProjectStatus = Object.freeze({
  SUGGESTED: '제안중',
  IN_PROGRESS: '진행중',
  COMPLETED: '종료',
  REPAIR: '하자보수중',
});

export const ProjectType = Object.freeze({
  STANDARD: '표준',
  RESEARCH: '연구개발',
});
